module.exports = __webpack_public_path__ + "static/media/mobile_heroFR_allday_break_fr.3ead84e1.jpg";